import { render, staticRenderFns } from "./gas_monitor.vue?vue&type=template&id=2b91d269&"
import script from "./gas_monitor.vue?vue&type=script&lang=js&"
export * from "./gas_monitor.vue?vue&type=script&lang=js&"
import style0 from "./gas_monitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports